import React, { useState } from 'react';
import { formatPrice, formatNumber } from './propertyData';

function PropertyCard({ property, isFavorite, onToggleFavorite, onClick, viewMode }) {
  const [imgIndex, setImgIndex] = useState(0);
  const p = property;

  const nextImg = (e) => {
    e.stopPropagation();
    setImgIndex((prev) => (prev + 1) % p.images.length);
  };

  const prevImg = (e) => {
    e.stopPropagation();
    setImgIndex((prev) => (prev - 1 + p.images.length) % p.images.length);
  };

  if (viewMode === 'list') {
    return (
      <div className="re-card-list" onClick={onClick}>
        <div className="re-card-list-image">
          <span className="re-card-emoji">{p.images[imgIndex]}</span>
          {p.isNew && <span className="re-badge new">New</span>}
          {p.priceReduced && <span className="re-badge reduced">Reduced</span>}
          {p.featured && <span className="re-badge featured">Featured</span>}
          <button className={`re-fav-btn ${isFavorite ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); onToggleFavorite(); }}>
            ♥
          </button>
        </div>
        <div className="re-card-list-body">
          <div className="re-card-list-top">
            <h3>{p.title}</h3>
            <div className="re-card-price-group">
              <span className="re-card-price">{formatPrice(p.price)}</span>
              {p.originalPrice && <span className="re-card-original">{formatPrice(p.originalPrice)}</span>}
            </div>
          </div>
          <p className="re-card-location">📍 {p.location}</p>
          <div className="re-card-stats">
            <span>🛏️ {p.beds} Beds</span>
            <span>🚿 {p.baths} Baths</span>
            <span>📐 {formatNumber(p.sqft)} sqft</span>
            {p.garage > 0 && <span>🚗 {p.garage} Garage</span>}
          </div>
          <p className="re-card-desc">{p.description.slice(0, 120)}...</p>
          <div className="re-card-list-footer">
            <span className="re-card-agent">{p.agent.avatar} {p.agent.name}</span>
            <span className="re-card-days">{p.daysOnMarket}d on market</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="re-card" onClick={onClick}>
      <div className="re-card-image">
        <span className="re-card-emoji">{p.images[imgIndex]}</span>
        {p.images.length > 1 && (
          <>
            <button className="re-img-nav prev" onClick={prevImg}>‹</button>
            <button className="re-img-nav next" onClick={nextImg}>›</button>
            <div className="re-img-dots">
              {p.images.map((_, i) => (
                <span key={i} className={`re-img-dot ${i === imgIndex ? 'active' : ''}`}></span>
              ))}
            </div>
          </>
        )}
        <div className="re-card-badges">
          {p.isNew && <span className="re-badge new">New</span>}
          {p.priceReduced && <span className="re-badge reduced">Price Reduced</span>}
          {p.featured && <span className="re-badge featured">Featured</span>}
        </div>
        <button className={`re-fav-btn ${isFavorite ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); onToggleFavorite(); }}>
          ♥
        </button>
      </div>
      <div className="re-card-body">
        <div className="re-card-price-row">
          <div className="re-card-price-group">
            <span className="re-card-price">${formatNumber(p.price)}</span>
            {p.originalPrice && <span className="re-card-original">${formatNumber(p.originalPrice)}</span>}
          </div>
          <span className="re-card-type">{p.type}</span>
        </div>
        <h3 className="re-card-title">{p.title}</h3>
        <p className="re-card-location">📍 {p.location}</p>
        <div className="re-card-stats">
          <span>🛏️ {p.beds}</span>
          <span>🚿 {p.baths}</span>
          <span>📐 {formatNumber(p.sqft)} sqft</span>
          {p.garage > 0 && <span>🚗 {p.garage}</span>}
        </div>
        <div className="re-card-footer">
          <span className="re-card-agent">{p.agent.avatar} {p.agent.name}</span>
          <span className="re-card-views">👁 {p.views}</span>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard;
